import requestInstance from '../../../utils/instance-utils';

export const getEnrolledSkills = (payload: { skillIds: number[] }) =>
    requestInstance.post('self-enrollment/enrolled-skills', payload);

export const createSelfEnrollment = (payload: {
    courseId: number;
    hasCE: boolean;
}) => requestInstance.post('self-enrollment', payload);

export const cancelSelfEnrollment = (payload: { selfEnrollmentId: number }) =>
    requestInstance.post('self-enrollment/cancel', payload);
